import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { InlineError } from './inlineError.js';
import { HashLink } from './heading.js';
const mathRenderer = ({ node }) => {
    if (node.type === 'math') {
        if (node.error || !node.html) {
            return (_jsxs("pre", { title: node.message, children: [_jsxs("span", { className: "text-red-500", children: [_jsx(ExclamationCircleIcon, { width: "1rem", height: "1rem", className: "inline mr-1" }), node.message, '\n\n'] }), node.value] }));
        }
        const id = node.html_id || node.identifier || node.key;
        return (_jsxs("div", { id: id, className: "flex my-5 group", children: [_jsx("div", { dangerouslySetInnerHTML: { __html: node.html }, className: "flex-grow overflow-x-auto overflow-y-hidden" }), node.enumerator && (_jsx("div", { className: "relative self-center flex-none pl-2 m-0 text-right select-none", children: _jsxs(HashLink, { id: id, kind: "Equation", className: "text-inherit hover:text-inherit", children: ["(", node.enumerator, ")"] }) }))] }));
    }
    if (node.error || !node.html) {
        return _jsx(InlineError, { value: node.value, message: node.message });
    }
    return _jsx("span", { dangerouslySetInnerHTML: { __html: node.html } });
    // return <Math html={node.html} value={node.value as string} />;
};
const MATH_RENDERERS = {
    math: mathRenderer,
    inlineMath: mathRenderer,
};
export default MATH_RENDERERS;
